/**
 * 検討中に追加/削除
 */
window.considerRegistrator = {
    /**
     * offer求人検討中[登録<->削除]切り替え
     *
     * @param e イベント
     * @param jobId
     * @param offClassName 検討中に追加ボタンに追加するクラス(任意)
     * @param onClassName 検討中から削除ボタンに追加するクラス(任意)
     */
    toggleOffer: function(e, jobId, offClassName, onClassName) {
        this._execute('job' , jobId, e, offClassName, onClassName);
    },

    /**
     * request求人検討中[登録<->削除]切り替え
     *
     * @param e イベント
     * @param officeId 
     * @param offClassName 検討中に追加ボタンに追加するクラス(任意)
     * @param onClassName 検討中から削除ボタンに追加するクラス(任意)
     */
    toggleRequest: function(e, officeId, offClassName, onClassName) {
        this._execute('office', officeId, e, offClassName, onClassName);
    },

    /**
     * [登録|削除]処理を実行する
     *
     * @param idType IDタイプ 'office' or 'job'
     * @param id ID
     * @param e イベント
     * @param offClassName 検討中に追加ボタンに追加するクラス(任意)
     * @param onClassName 検討中から削除ボタンに追加するクラス(任意)
     */
    _execute: function(idType, id, e, offClassName, onClassName) {
        if (idType !== 'office' && idType !== 'job') {
            return;
        }

        const $element = $(e.currentTarget);

        if (this._isInProcessing($element)) {
            return;
        }

        this._startProcessing($element);

        const isInConsider = this._isInConsider($element);
        const apiEndPoint = '/api/consider/' + (isInConsider ? 'delete' : 'insert') + '/' + (idType === 'office' ? 'office_id' : 'job_id') +'/';
        const paramJson = (idType === 'office') ? {office_id: id} : {job_id: id};
        const headerSettings = {
            headers: {
                'X-CSRF-TOKEN': window.Laravel.csrfToken,
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json'
            }
        };

        $.ajax({
            url: apiEndPoint,
            type: 'POST',
            data: paramJson,
            headers: headerSettings,
        })
        .done((data) => {
            if (isInConsider) {
                this._toUnconsideredView($element, offClassName, onClassName);
            } else {
                this._toInConsiderView($element, offClassName, onClassName);
                this._showInsertedView();
            }
        })
        .fail((data) => {
            console.error(data);
        })
        .always((data) => {
            this._endProcessing($element);
        });
    },

    /**
     * 検討中に登録済みか判定する
     *
     * @param $element 
     */
    _isInConsider: function($element) {
        return $element.hasClass('is-active');
    },

    /**
     * 登録済みの表示に切り替える
     *
     * @param $element 
     * @param offClassName 検討中に追加ボタンに追加するクラス(任意)
     * @param onClassName 検討中から削除ボタンに追加するクラス(任意)
     */
    _toInConsiderView: function($element, offClassName, onClassName) {
        $element.addClass('is-active');
        if (offClassName) {
            $element.removeClass(offClassName);
            $element.find('*').removeClass(offClassName);
        }
        if (onClassName) {
            $element.addClass(onClassName);
            $element.find('*').addClass(onClassName);
        }
    },

    /**
     * 未登録の表示に切り替える
     *
     * @param $element 
     * @param offClassName 検討中に追加ボタンに追加するクラス(任意)
     * @param onClassName 検討中から削除ボタンに追加するクラス(任意)
     */
    _toUnconsideredView: function($element, offClassName, onClassName) {
        $element.removeClass('is-active');
        if (offClassName) {
            $element.addClass(offClassName);
            $element.find('*').addClass(offClassName);
        }
        if (onClassName) {
            $element.removeClass(onClassName);
            $element.find('*').removeClass(onClassName);
        }
    },

    /**
     * 登録処理中かどうか
     *
     * @param $element 
     */
    _isInProcessing: function($element) {
        return $element.hasClass('js-inprocessing');
    },

    /**
     * 登録開始処理を行う
     *
     * @param $element 
     */
    _startProcessing: function($element) {
        $element.addClass('js-inprocessing');
    },

    /**
     * 登録終了処理を行う
     *
     * @param $element 
     */
    _endProcessing: function($element) {
        $element.removeClass('js-inprocessing');
    },

    /**
     * 登録完了の表示を行う
     */
    _showInsertedView: function() {
        $('#js-considerModal').addClass('is-open');
    }
}
